import {toString} from "../../helpers/helpers";

export interface AssetWithoutCollectionModel {
  productNumber: string;
  serialNumber: string;
  k2Customer: string;
  ipAddress: string;
  hostName: string;
  status: string;
  k2IpAddress: string;
  k2HostName: string;
}

export function assetWithoutCollectionModelFactory(json?: any): AssetWithoutCollectionModel {
  json = json || {};

  return {
    productNumber: toString(json.productNumber),
    serialNumber: toString(json.serialNumber),
    k2Customer: toString(json.k2Customer),
    ipAddress: toString(json.ipAddress),
    hostName: toString(json.hostName),
    status: toString(json.status),
    k2IpAddress: toString(json.k2IpAddress),
    k2HostName: toString(json.k2HostName),
  } as AssetWithoutCollectionModel;
}

export type AssetWithoutCollectionResponse = {
  assetsWithoutCollections: AssetWithoutCollectionModel[];
  message: string;
};
